//#region src/olo_order_history_source.ts
let OloOrderHistorySource = /* @__PURE__ */ function(OloOrderHistorySource) {
	OloOrderHistorySource["RecentProducts"] = "recent-products";
	OloOrderHistorySource["RecentOrders"] = "recent-orders";
	return OloOrderHistorySource;
}({});
//#endregion
export { OloOrderHistorySource };

//# sourceMappingURL=olo_order_history_source.js.map